import Cookies from "js-cookie";
import http from "../../index";
import { Admin } from "./types";

namespace auth {
  const tokenKey = "app.token";
  const orgKey = "org.id";

  export const remToken = () => {
    Cookies.remove(tokenKey);
  };

  export const hasToken = () => !!Cookies.get(tokenKey);

  export const getToken = () => Cookies.get(tokenKey);

  export const setOrg = (id: string | undefined) => {
    if (id) localStorage.setItem(orgKey, id);
  };

  export const getOrg = () => localStorage.getItem(orgKey);

  export const info = () =>
    http.get<Admin>("shared/auth/info", { hasAuth: true });
}

export default auth;
